// src/pages/Home.jsx
import React from 'react';
import { motion } from 'framer-motion';
import CTAButton from '../components/CTAButton';
import heroImage from '../assets/images/img-hero.webp';

const Home = () => {
    return (
        <div className="w-full min-h-screen bg-white text-gray-800">
            {/* Fundo com Gradiente */}
            <section className="w-full h-20" style={{ background: 'linear-gradient(to right, #301e6c, #0b2b49)' }}></section>

            {/* Hero Section */}
            <section
                className="relative w-full h-screen bg-cover bg-center"
                loading="lazy"
                style={{
                    backgroundImage: `url(${heroImage})`,
                    backgroundPosition: 'top', // Posiciona a imagem no topo
                    backgroundSize: 'cover',  // A imagem vai cobrir toda a área disponível
                    height: '70vh' // Altura ajustada para o hero
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-b from-black to-transparent opacity-70"></div>
                <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-6 md:px-12">
                    <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 text-shadow-md">
                        Transforme suas vendas com Inteligência Artificial
                    </h1>
                    <p className="text-lg sm:text-xl md:text-2xl mb-6 text-shadow-md">
                        Automação inteligente para acelerar seus resultados e melhorar a experiência do cliente.
                    </p>

                    {/* Botão Ajustado */}
                    <CTAButton
                        text="Entrar em Contato"
                        onClick={() => window.scrollTo(0, document.body.scrollHeight)}
                        className="w-full sm:w-auto py-4 px-8 text-lg sm:text-xl rounded-full bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-400 transform transition-all duration-300"
                    />
                </div>
            </section>

            {/* Destaque de Funcionalidades */}
            <section className="py-16 bg-gray-100">
                <h2 className="text-center text-3xl font-bold text-purple-800 mb-8">O que podemos fazer por você</h2>
                <div className="grid md:grid-cols-3 gap-8 px-8">
                    <motion.div
                        className="bg-white shadow-xl p-6 rounded-2xl text-center"
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: 'spring', stiffness: 300 }}
                    >
                        <div className="text-5xl text-purple-800 mb-4">🤖</div>
                        <h3 className="text-2xl font-semibold">Automação Total</h3>
                        <p>Automatize suas interações com clientes de forma simples e eficiente.</p>
                    </motion.div>
                    <motion.div
                        className="bg-white shadow-xl p-6 rounded-2xl text-center"
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: 'spring', stiffness: 300 }}
                    >
                        <div className="text-5xl text-purple-800 mb-4">📊</div>
                        <h3 className="text-2xl font-semibold">Análise de Dados</h3>
                        <p>Receba insights em tempo real para tomar decisões mais rápidas e baseadas em dados.</p>
                    </motion.div>
                    <motion.div
                        className="bg-white shadow-xl p-6 rounded-2xl text-center"
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: 'spring', stiffness: 300 }}
                    >
                        <div className="text-5xl text-purple-800 mb-4">💬</div>
                        <h3 className="text-2xl font-semibold">Integração com WhatsApp</h3>
                        <p>Converse diretamente com seus clientes via WhatsApp, automatizando respostas e aumentando o engajamento.</p>
                    </motion.div>
                </div>
            </section>

            {/* Depoimentos */}
            <section className="py-16 bg-white">
                <h2 className="text-center text-3xl font-bold text-purple-800 mb-8">O que nossos clientes dizem</h2>
                <div className="flex justify-center space-x-8">
                    <motion.div
                        className="bg-gray-100 p-6 rounded-lg shadow-lg w-full sm:w-1/3"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        <p className="italic">"O SmartSalesBot revolucionou nossa estratégia de vendas. A automação é incrível!"</p>
                        <p className="mt-4 font-semibold">João Silva - CEO</p>
                    </motion.div>
                    <motion.div
                        className="bg-gray-100 p-6 rounded-lg shadow-lg w-full sm:w-1/3"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        <p className="italic">"A integração com o WhatsApp trouxe uma nova dinâmica ao nosso atendimento e aumentou as conversões." </p>
                        <p className="mt-4 font-semibold">Maria Oliveira - Gerente Comercial</p>
                    </motion.div>
                </div>
            </section>

            {/* Call to Action Final */}
            <section className="py-12 bg-purple-800 text-white text-center">
                <h2 className="text-3xl font-bold mb-4">Pronto para aumentar suas vendas?</h2>
                <p className="text-lg mb-8">Experimente agora e veja como podemos ajudar a transformar seu processo de vendas.</p>
                <CTAButton text="Comece Agora" onClick={() => alert('Iniciar demo')} />
            </section>
        </div>
    );
};

export default Home;

